import userManualHttp from './userManualHttp';

const getPdfUserManual = (context) => {
  return new Promise((resolve, reject) => {
    userManualHttp.getPdfUserManual(context)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getPdfUserManual
};



// WEBPACK FOOTER //
// ./src/api/userManual/index.js